import type React from 'react';

export function Star(props: React.SVGProps<SVGSVGElement>) {
	return (
		<svg
			width="556"
			height="582"
			viewBox="0 0 556 582"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M263.381 6.6589C271.287 -1.80983 284.713 -1.80983 292.619 6.6589L342.755 60.3603C347.456 65.3953 354.416 67.6571 361.179 66.3466L433.304 52.3703C444.679 50.1662 455.54 58.0575 456.959 69.5561L465.954 142.471C466.798 149.307 471.1 155.228 477.341 158.143L543.907 189.23C554.404 194.133 558.553 206.901 552.942 217.037L517.362 281.314C514.026 287.34 514.026 294.66 517.362 300.686L552.942 364.963C558.553 375.099 554.404 387.867 543.907 392.77L477.341 423.857C471.1 426.772 466.798 432.693 465.954 439.529L456.959 512.444C455.54 523.942 444.679 531.834 433.304 529.63L361.179 515.653C354.416 514.343 347.456 516.605 342.755 521.64L292.619 575.341C284.713 583.81 271.287 583.81 263.381 575.341L213.245 521.64C208.544 516.605 201.584 514.343 194.821 515.653L122.696 529.63C111.321 531.834 100.46 523.942 99.0414 512.444L90.0456 439.529C89.2022 432.693 84.9002 426.772 78.659 423.857L12.0931 392.77C1.59565 387.867 -2.55305 375.099 3.05797 364.963L38.6383 300.686C41.9743 294.66 41.9743 287.34 38.6383 281.314L3.05797 217.037C-2.55305 206.901 1.59565 194.133 12.0931 189.23L78.659 158.143C84.9002 155.228 89.2022 149.307 90.0456 142.471L99.0414 69.5561C100.46 58.0575 111.321 50.1662 122.696 52.3703L194.821 66.3466C201.584 67.6571 208.544 65.3953 213.245 60.3603L263.381 6.6589Z"
				fill="currentColor"
			/>
		</svg>
	);
}
